import SessionsListBlock from './SessionsListBlock';

export default SessionsListBlock;
